/// import './inputMask.d.ts'
import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
} from 'react-hook-form';
import { InputContainer } from '../styles';
import InputMask from 'react-input-mask';

interface InputMaskProps {
  label?: string;
  name: string;
  // register: UseFormRegister<FieldValues>;
  isError: boolean;
  alwaysShowMask?: boolean;
  control: Control<FieldValues, any>;
}

export const InputMaskRg: React.FC<InputMaskProps> = ({
  label = '',
  name,
  isError,
  alwaysShowMask = false,
  control,
  ...rest
}) => {
  return (
    <>
      <InputContainer>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange, onBlur, ref } }) => {
              return (
                <InputMask
                  formatChars={{
                    X: '[0-9xX]',
                    9: '[0-9]',
                  }}
                  mask="99.999.999-X"
                  alwaysShowMask={alwaysShowMask}
                  // maskPlaceholder="00.000.000-0"
                  placeholder="00.000.000-0"
                  onChange={(event) =>
                    onChange(event.target.value.toUpperCase())
                  }
                  onBlur={onBlur}
                  value={value || ''}
                  className={
                    isError ? 'form-control is-invalid' : 'form-control'
                  }
                  {...rest}
                >
                  {(inputProps: any) => {
                    return (
                      <input
                        {...inputProps}
                        name={name}
                        type="text"
                        ref={ref}
                      />
                    );
                  }}
                </InputMask>
              );
            }}
          />
        </Form.Group>
      </InputContainer>
    </>
  );
};
